export default {"src":"/_next/static/image/src/images/banner-fullwidth-orange.0df59bd88426d9c340185db46cf1c298.svg","height":238,"width":368};